import { useTranslation } from 'react-i18next';
import React from 'react';

import InfoIcon from '@mui/icons-material/Info';
import { Grid, InputAdornment, Tooltip } from '@mui/material';

import { modelPath } from '@libs/helpers/form';
import { ConnectedTextField } from '@libs/ui/components/form/text-field';

import { ApplicationFormState } from '../../types';

interface BirthDateFieldsProps {
  showOnlyRequired?: boolean;
}

/**
 * Reusable component for month and day of birth fields
 * Used in both Default and Bayer Social Security ID components
 */
export const BirthDateFields: React.FC<BirthDateFieldsProps> = ({
  showOnlyRequired = false,
}) => {
  const { t } = useTranslation('jobForm');

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} sm={6}>
        <ConnectedTextField
          name={modelPath<ApplicationFormState>((i) => i.details.monthOfBirth)}
          fullWidth
          variant="filled"
          label={t('applicationForm.socialSecurity.monthOfBirth')}
          placeholder="2"
          type="number"
          inputProps={{ min: 1, max: 12 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title={t('applicationForm.socialSecurity.monthTooltip')}>
                  <InfoIcon fontSize="small" />
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <ConnectedTextField
          name={modelPath<ApplicationFormState>((i) => i.details.dayOfBirth)}
          fullWidth
          variant="filled"
          label={t('applicationForm.socialSecurity.dayOfBirth')}
          placeholder="5"
          type="number"
          inputProps={{ min: 1, max: 31 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title={t('applicationForm.socialSecurity.dayTooltip')}>
                  <InfoIcon fontSize="small" />
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
    </Grid>
  );
};
